import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import HeaderPage from './../block/HeaderPage'
import LoginForm from './../block/LoginForm'
import Breadcrumbs from './../block/Breadcrumbs'

import { Button, Container, ListGroup, Form, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      name: '',
      email: '',
      phone: '',
      dob: '',
      show: false,
      modal_text: ``,
      loading: true
    }
  }

  priceFormat(price, delimiter, fraction) {
    if(price == 0 || price == '') return 0
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  submitForm = ( e ) => {
    const { id, name, email, phone, dob } = this.state
    e.preventDefault()

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'save_user_fields',
      'id': id,
      'name': name,
      'email': email,
      'phone': phone,
      'dob': dob
    }).then( ( response ) => {
      if( response.data.result ) {
        this.setState({
          name: response.data.fullname,
          email: response.data.email,
          phone: response.data.mobilephone,
          dob: response.data.dob == `` ? `` : response.data.dob
        }, () => {
          this.handleShow( `Ваши данные успешно обновлены` )
        })
      } else {
        this.handleShow( `Ошибка, проверьте поля формы` )
      }
    })
  }

  change_name( value ) {
    this.setState({
      name: value
    })
  }
  change_email( value ) {
    this.setState({
      email: value
    })
  }
  change_phone( value ) {
    this.setState({
      phone: value
    })
  }
  change_dob( value ) {
    this.setState({
      dob: value
    })
  }

  handleShow( text ) {
    this.setState({
      show: true,
      modal_text: text
    })
  }
  handleClose() {
    this.setState({
      show: false
    }, () => {
      window.location.reload()
    })
  }

  logOut() {
    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'logout'
    }).then( ( response ) => {
      if( response.data.result ) {
        location.reload()
      }
    })
  }

  componentDidMount() {
    this.setState({
      loading: false
    }, () => {
      if(!( 'user' in this.props.ajax_data )) return
      const { user } = this.props.ajax_data

      if(!user.authorized) return
      this.setState({
        id: user.id,
        name: user.fullname,
        email: user.email,
        phone: user.mobilephone,
        dob: user.dob == `` ? `` : user.dob
      })
    })
  }

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart } = this.props,
    { name, email, phone, dob, show, modal_text, loading } = this.state

    if (loading) {
      return (
        <>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          <div className='w-100 d-flex align-items-center' style={{ flex: 1 }}>
            <div className="container text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p className="mt-3">Загрузка данных...</p>
            </div>
          </div>
        </>
      )
    }

    const teyca = (
      <>
        {ajax_data.teyca != null &&
          <>
            <div className={styles.teyca_title}>Программа лояльности</div>
            <div className={styles.teyca_card}>
              <div style={{ background: `center / cover no-repeat url('/assets/images/teyca_bg.png')` }} className={styles.teyca_card_img}>
                <div className={styles.teyca_card_name}>{ajax_data.teyca.name}</div>
                <div>
                  <div className={styles.teyca_card_card_title}>Номер карты</div>
                  <div className={styles.teyca_card_card}>{ajax_data.teyca.card}</div>
                </div>
              </div>
              <div className={styles.teyca_card_body}>
                <div className={styles.teyca_card_body_title}>Сумма покупок за период</div>
                <div className={styles.teyca_card_body_text}>{this.priceFormat(ajax_data.teyca.summ)}₽</div>
                <div className={styles.teyca_card_body_title}>Скидка</div>
                <div className={styles.teyca_card_body_text}>{ajax_data.teyca.discount}% от суммы покупки</div>
              </div>
            </div>
            <div className={styles.teyca_card_b}>
              <div>
                <div className={styles.teyca_card_b_text}>
                  {this.priceFormat(ajax_data.teyca.bonus)}
                </div>
                <div className={styles.teyca_card_b_name}>Бонусы</div>
              </div>
              <div>
                <div className={styles.teyca_card_b_text}>
                  {ajax_data.teyca.loyalty_level}
                </div>
                <div className={styles.teyca_card_b_name}>Уровень</div>
              </div>
            </div>
          </>
        }
        <div className="d-flex justify-content-center justify-content-sm-start align-items-center mt-4">
          <div>
            <div className={styles.shopsng_svaztitle}>Связаться с нами</div>
            {page_data.phone &&
              <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')} className={styles.shopsng_svazphone}>{page_data.phone}</a>
            }
          </div>
          {page_data.tg &&
            <a className={styles.shopsng_svazicon} href={page_data.tg}>
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
              </svg>
            </a>
          }
        </div>
      </>
    )

    return (
      <>
        <HeaderPage
          ajax_data={ajax_data}
          page_data={page_data}
          changeTopSearch={changeTopSearch}
          changeLeftMenuh={changeLeftMenuh}
          favorite={favorite}
          cart={cart}
        />
        {'user' in ajax_data &&
          <div className='w-100' style={{ flex: 1 }}>
            {ajax_data != null &&
              <>
                {ajax_data.user.authorized ?
                  <>
                    <Breadcrumbs
                      pages={[
                        {
                          name: ajax_data.pagetitle,
                          current: true
                        }
                      ]}
                    />
                    <div className={styles.lk_page}>
                      <Container>
                        <h1>{ajax_data.seo_h1}</h1>
                        <div className={styles.lk_page_block}>
                          <div className={styles.lk_page_block_left}>
                            <ListGroup className={styles.lk_page_block_left_list}>
                              <ListGroup.Item as="a" href={page_data.orders_link} className={styles.lk_page_block_left_mitem}>
                                <div>Мои заказы</div>
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.7083 15.7083C14.5577 15.7083 13.625 16.6411 13.625 17.7917C13.625 18.9423 14.5577 19.875 15.7083 19.875C16.8589 19.875 17.7917 18.9423 17.7917 17.7917C17.7917 16.6411 16.8589 15.7083 15.7083 15.7083ZM15.7083 15.7083H7.68119C7.20092 15.7083 6.96034 15.7083 6.76261 15.6229C6.58818 15.5475 6.43686 15.4262 6.3266 15.2714C6.20302 15.0979 6.15332 14.866 6.05494 14.4068L3.49113 2.44234C3.39046 1.97254 3.33945 1.73789 3.21444 1.56242C3.10418 1.40766 2.95288 1.28585 2.77845 1.21047C2.58068 1.125 2.34145 1.125 1.86097 1.125H1.125M4.25 4.25H17.6596C18.4115 4.25 18.787 4.25 19.0393 4.40662C19.2604 4.54382 19.4222 4.75898 19.4928 5.00938C19.5733 5.29524 19.4698 5.65621 19.2614 6.3786L17.8191 11.3786C17.6945 11.8105 17.6322 12.0261 17.5058 12.1863C17.3942 12.3278 17.2471 12.4385 17.0803 12.5065C16.8918 12.5833 16.6678 12.5833 16.2209 12.5833H6.05257M6.33333 19.875C5.18274 19.875 4.25 18.9423 4.25 17.7917C4.25 16.6411 5.18274 15.7083 6.33333 15.7083C7.48393 15.7083 8.41667 16.6411 8.41667 17.7917C8.41667 18.9423 7.48393 19.875 6.33333 19.875Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </ListGroup.Item>
                              <ListGroup.Item as="a" href={page_data.adresa_link} className={styles.lk_page_block_left_mitem}>
                                <div>Адреса доставки</div>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 8.63122V13.8671C1 14.9638 1 15.5125 1.21799 15.9313C1.40973 16.2998 1.71547 16.5991 2.0918 16.7868C2.5192 17 3.07899 17 4.19691 17H13.8031C14.921 17 15.48 17 15.9074 16.7868C16.2837 16.5991 16.5905 16.2998 16.7822 15.9313C17 15.5129 17 14.965 17 13.8705V8.63122C17 8.10808 16.9995 7.84636 16.9346 7.60293C16.877 7.3872 16.7825 7.18305 16.6546 6.99857C16.5102 6.7904 16.3096 6.61777 15.9074 6.27328L11.1074 2.16126C10.3608 1.52166 9.98751 1.20203 9.56738 1.08039C9.19719 0.973204 8.80261 0.973204 8.43242 1.08039C8.01261 1.20193 7.63985 1.52127 6.89436 2.1599L2.09277 6.27328C1.69064 6.61777 1.49004 6.7904 1.3457 6.99857C1.21779 7.18305 1.12255 7.3872 1.06497 7.60293C1 7.84636 1 8.10807 1 8.63122Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </ListGroup.Item>
                              <ListGroup.Item as="a" href={page_data.favorite_link} className={styles.lk_page_block_left_mitem}>
                                <div>Избранное</div>
                                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 4.2002V13.6854C1 15.0464 1 15.7268 1.20412 16.1433C1.58245 16.9151 2.41157 17.3588 3.26367 17.2454C3.7234 17.1842 4.28964 16.8067 5.4221 16.0518L5.42481 16.0499C5.87368 15.7507 6.09815 15.6011 6.33295 15.5181C6.76421 15.3656 7.23476 15.3656 7.66602 15.5181C7.90129 15.6012 8.12664 15.7515 8.57732 16.0519C9.70978 16.8069 10.2767 17.1841 10.7364 17.2452C11.5885 17.3586 12.4176 16.9151 12.7959 16.1433C13 15.7269 13 15.0462 13 13.6854V4.19691C13 3.07899 13 2.5192 12.7822 2.0918C12.5905 1.71547 12.2837 1.40973 11.9074 1.21799C11.4796 1 10.9203 1 9.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40973 1.40973 1.71547 1.21799 2.0918C1 2.51962 1 3.08009 1 4.2002Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </ListGroup.Item>
                              <ListGroup.Item onClick={() => this.logOut()} className={styles.lk_page_block_left_mitem}>
                                <div>Выйти из аккаунта</div>
                                <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.918 1H19.2513C19.8036 1 20.2513 1.44772 20.2513 2V13C20.2513 13.5523 19.8036 14 19.2513 14H15.918" stroke="black" strokeLinecap="round"/>
                                  <path d="M0.75 7.49922L5.08333 12.0492M0.75 7.49922L5.08333 2.94922M0.75 7.49922H16.35" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                              </ListGroup.Item>
                            </ListGroup>
                            <div className='d-none d-lg-block w-100'>
                              {teyca}
                            </div>
                          </div>

                          <div className={styles.lk_page_block_right}>
                            <Form className={styles.lk_page_block_right_form} onSubmit={( e ) => this.submitForm( e )}>
                              <Form.Control required name="name" className={styles.login_form_input} type="text" value={name} onChange={( e ) => this.change_name( e.target.value )} placeholder="Введите имя" />
                              <Form.Control required name="email" className={styles.login_form_input} type="email" value={email} onChange={( e ) => this.change_email( e.target.value )} placeholder="Введите почту" />
                              <Form.Control required name="phone" as={IMaskInput} mask="+{7} (000) 000-00-00" lazy={true} type="phone" className={styles.login_form_input} value={phone} onChange={( e ) => this.change_phone( e.target.value )} placeholder="Введите ваш номер телефона" />
                              <Form.Control name="dob" className={styles.login_form_input} type="date" value={dob} onChange={( e ) => this.change_dob( e.target.value )} placeholder="Введите дату рождения" />
                              <Button type="submit" variant={`dark`} className={styles.lk_page_block_right_form_btn}>Сохранить</Button>
                              <div className={styles.lk_page_block_right_pconf}>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="0.375" y="0.375" width="16.25" height="16.25" fill="white" stroke="black" strokeWidth="0.75"/>
                                  <rect x="5" y="5" width="7" height="7" fill="black"/>
                                </svg>
                                <div>Я ознакомлен и согласен с условиями <a href={page_data.pconf_link}>оферты и политики конфиденциальности</a></div>
                              </div>
                              <div className={styles.lk_page_block_right_pconf}>
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect x="0.375" y="0.375" width="16.25" height="16.25" fill="white" stroke="black" strokeWidth="0.75"/>
                                </svg>
                                <div>Даю согласие на получение новостей и акций бренда</div>
                              </div>
                            </Form>
                          </div>
                        </div>

                        <div className='d-lg-none w-100'>
                          {teyca}
                        </div>
                      </Container>
                    </div>
                  </>
                :
                  <>
                    <Breadcrumbs
                      pages={[
                        {
                          name: `Вход в учетную запись`,
                          current: true
                        }
                      ]}
                    />
                    <LoginForm
                      ajax_data={ajax_data}
                    />
                  </>
                }
              </>
            }
          </div>
        }
        {ajax_data != null &&
          <Modal centered show={show} onHide={() => this.handleClose()}>
            <Modal.Header closeButton>
              <Modal.Title>{ajax_data.pagetitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{modal_text}</Modal.Body>
          </Modal>
        }
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array
}